export const RADIO_BUTTON_NO = 'no';
export const RADIO_BUTTON_YES = 'yes';
export const RADIO_BUTTON_PREFER_NOT_TO_SAY = 'prefer not to say';
